import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {LoaderService} from "../../fw/loader/loader.service";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class AzureApiService {
    private BASE_URL: string = 'https://msofficeapi.azurewebsites.net/api/';
    //private BASE_URL: string = 'http://localhost:51635/api/';

    constructor(
        private http: HttpClient,
        private ls: LoaderService) { }

    get<T>(url: string): Observable<T> {
        this.ls.show();
        return this.http.get<T>(this.BASE_URL + encodeURIComponent(url)).finally(() => this.ls.hide());
    };

    post<T>(url: string, body: any): Observable<T> {
        this.ls.show();
        return this.http.post<T>(this.BASE_URL + encodeURIComponent(url), body).finally(() => this.ls.hide());
    };

    put<T>(url: string, body: any): Observable<T> {
        this.ls.show();
        return this.http.put<T>(this.BASE_URL + encodeURIComponent(url), body).finally(() => this.ls.hide());
    };

    delete<T>(url: string): Observable<T> {
        this.ls.show();
        return this.http.delete<T>(this.BASE_URL + encodeURIComponent(url)).finally(() => this.ls.hide());
    };

    patch<T>(url: string, body: any): Observable<T> {
        this.ls.show();
        return this.http.patch<T>(this.BASE_URL + encodeURIComponent(url), body).finally(() => this.ls.hide());
    };

    public GetReportServiceUrl = () : string => {
      return this.BASE_URL + 'reports/';
    };
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/services/azure-api.service.ts